<script>
import TwNavigation from './components/TwNavigation';
import TwMainToolbar from './components/TwMainToolbar';
import TwSnackbar from './components/TwSnackbar';

export default {
  name: 'App',
  components: {
    TwNavigation,
    TwMainToolbar,
    TwSnackbar,
  },
  mounted() {
    this.$Progress.finish();
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },
};
</script>

<template>
  <div id="app">
    <v-app>
      <v-responsive id="app-wrapper" min-width="1280px">
        <tw-snackbar/>
        <tw-navigation/>
        <tw-main-toolbar/>
        <router-view></router-view>
      </v-responsive>
    </v-app>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>



// WEBPACK FOOTER //
// src/App.vue